import React, { useState } from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";
import "./Products.css";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { fetchAllWarehouseProducts } from "../../../services/product.service";
import { generateExcelFile } from "./productExportWarehouse";
import { TotalSpaceColumn, Dimensions, Weight } from "./ProductService";

import ProductTable from "../../../Components/BoltTable/BoltTable";
import Tooltip from "../../../Components/Tooltip/Tooltip";

import ImagesModal from "../Components/ImagesModal/ImagesModal";
import ProductDetailsModal from "../Components/ProductDetailsModal/ProductDetailsModal";
import ProductHistoryModal from "../Components/HistoryModal/HistoryModal";
import WarehouseProductQty from "../Components/ProductQuantityModal/WarehouseProductQty";
import ProductSKUModal from "../Components/ProductSKUModal/ProductSKUModal";
import ProductLocationModal from "../Components/LocationModal/LocationModal";
import ProductFulfilmentCostModal from "../Components/FulfilmentCostModal/FulfilmentCostModal";
import LabelModal from "../Components/LabelModal/LabelModal";
import ProductDimensionModal from "../Components/ProductDimensionModal/ProductDimensionModal";
import ProductWeightModal from "../Components/ProductWeightModal/ProductWeightModal";
import StorageBreakdownModal from "../StorageBreakdown/StorageBreakdownModal";

import noImage from "../../../assets/images/noImage.png";
import { FcPlus } from "react-icons/fc";
import { PiExportLight } from "react-icons/pi";
import ActionDropDown from "./ActionDropDown/ActionDropDown";
import BoltButton from "../../../Components/UI/Buttons/BoltButton";
import BulkActionBar, {
  BulkActionButton,
} from "../../../Components/BoltTable/Components/BulkActionBar";
import { useTranslation } from "react-i18next";

const WarehouseProduct = () => {
  const { t } = useTranslation(["inventory", "common"]);
  const [Products, setProducts] = useState([]);
  const [imagesModal, setImagesModal] = useState();
  const [prodDetailsModal, setProdDetailsModal] = useState(false);
  const [prodHistoryModal, setProdHistoryModal] = useState(false);
  const [prodStorageModal, setProdStorageModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [updateQuantityModal, setUpdateQuantityModal] = useState(false);
  const [updateSKUModal, setUpdateSKUModal] = useState(false);
  const [updateLocationModal, setUpdateLocationModal] = useState(false);
  const [labelModal, setLabelModal] = useState(false);
  const [updateFulfilmentCostModal, setUpdateFulfilmentCostModal] =
    useState(false);
  const [prodDimensionModal, setProdDimensionModal] = useState(false);
  const [productWeightModal, setProductWeightModal] = useState(false);

  const setSnack = useSnackBar();

  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  const ImageUrl = (row) => {
    const url =
      row?.media.find((media) => media.is_primary === "true")?.file ||
      row?.media[0]?.file;
    return url || noImage;
  };

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("products.client"),
      field_name: "username",
      searchable: true,
      render: (row) => <> {row.shipper?.username ?? "-"}</>,
      width: "150px",
      fixed: "left",
    },
    {
      id: 2,
      label: t("products.productId"),
      field_name: "code",
      searchable: true,
      render: (row) => <>{row.code ?? "-"}</>,
      width: "150px",
    },
    {
      id: 3,
      label: t("products.image"),
      field_name: "image",
      render: (row) => (
        <img
          src={ImageUrl(row)}
          style={{ cursor: "pointer" }}
          onClick={() => setImagesModal(row?.id)}
          onError={(e) => {
            e.target.src = noImage;
          }}
          loading="lazy"
        />
      ),
    },
    {
      id: 4,
      label: t("products.name"),
      field_name: "name",
      searchable: true,
      render: (row) => <>{row.name ?? "-"}</>,
      width: "140px",
    },
    {
      id: 5,
      label: t("products.sku"),
      field_name: "product_sku",
      searchable: true,
      render: (row) => <>{row.product_sku ?? "-"}</>,
      width: "150px",
    },
    {
      id: 6,
      label: t("products.dimensionsLWH"),
      field_name: "dimensions",
      render: (row, rowIndex, handleFieldChange) => (
        <div
          onClick={() =>
            setProdDimensionModal({ row, rowIndex, handleFieldChange })
          }
          style={{ cursor: "pointer" }}
        >
          <Dimensions
            length={row?.length ?? 0}
            width={row?.width ?? 0}
            height={row?.height ?? 0}
            unit={row?.dimension_unit?.toLowerCase() === "in" ? "inch" : "cm"}
            space={true}
          />
        </div>
      ),
      width: "200px",
    },
    {
      id: 7,
      label: t("products.volume"),
      field_name: "total-volume",
      render: (row) => (
        <>
          <TotalSpaceColumn
            length={row?.length ?? 0}
            width={row?.width ?? 0}
            height={row?.height ?? 0}
            unit={row?.dimension_unit === "in" ? "inch" : "cm"}
            quantity={row?.product_warehouse?.[0]?.["quantity"] ?? 0}
            space={true}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 8,
      label: t("products.weight"),
      field_name: "weight",
      render: (row) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => setProductWeightModal(row)}
        >
          <Weight
            weight={row?.weight ?? 0}
            unit={row?.weight_unit?.toLowerCase() === "lb" ? "lb" : "kg"}
            space={true}
          />
        </div>
      ),
    },
    {
      id: 9,
      label: t("products.quantity"),
      field_name: "quantity",
      render: (row) => (
        <div
          onClick={() => setUpdateQuantityModal({ row })}
          className="cursor-pointer text-center rounded hover:bg-[#a79f9f14]"
        >
          {(() => {
            const productWarehouse = row?.product_warehouse?.[0] || {};
            const total = Number(productWarehouse?.quantity) || 0;
            const totalStock =
              Number(productWarehouse?.grn_details_sum_quantity) || 0;
            const receivedStock =
              Number(productWarehouse?.grn_details_sum_received_quantity) || 0;
            const expStock = totalStock - receivedStock;

            return (
              <>
                <span className={total < 0 ? "text-state-danger-text" : ""}>
                  {total}
                </span>
                {expStock != 0 && (
                  <span className="text-state-success-text">
                    +{expStock}{t("products.exp")}
                  </span>
                )}
              </>
            );
          })()}
        </div>
      ),
    },
    {
      id: 10,
      label: t("products.lotBatch"),
      field_name: "product_lots",
      render: (row) => (
        <>
          {row?.product_warehouse?.[0]?.product_lots?.length > 0 && (
            <>
              {row?.product_warehouse?.[0]?.product_lots?.map((lot, index) => (
                <div key={index}>
                  {lot?.name} ({lot?.product_pallets_sum_quantity})
                </div>
              ))}
            </>
          )}
        </>
      ),
      width: "140px",
    },
    {
      id: 11,
      label: t("products.pallet"),
      field_name: "Pallet",
      render: (row) => (
        // <div
        //   className="product_dimension_parent_wrapper"
        //   style={{ maxWidth: "200px" }}
        // >
        //   <div
        //     className="product__notification_circle_wrapper"
        //     onClick={() => setProdStorageModal(row)}
        //   >
        //     <FaPallet
        //       style={{
        //         color: row?.product_warehouse?.[0]?.palletise ? "var(--color-brand)" : "",
        //       }}
        //       size={10}
        //     />
        //     {row?.product_warehouse?.[0]?.palletise ? (
        //       <div className="product__notification_circle">
        //         {row?.product_warehouse?.[0]?.product_pallets_count}
        //       </div>
        //     ) : null}
        //   </div>
        // </div>
        <Tooltip title={t("products.clickToUpdate")}>
          <div
            onClick={() => setProdStorageModal(row)}
            style={{ cursor: "pointer" }}
          >
            {row?.product_warehouse?.[0]?.product_pallets_count ?? "0"}
          </div>
        </Tooltip>
      ),
    },
    {
      id: 12,
      label: t("products.brand"),
      field_name: "brand",
      searchable: true,
      render: (row) => <>{row?.brand?.name.toUpperCase() || ""}</>,
      width: "140px",
    },
    {
      id: 13,
      label: t("products.categDiv"),
      field_name: "category",
      searchable: true,
      render: (row) => <>{row?.category?.name.toUpperCase() || ""}</>,
      width: "140px",
    },
    {
      id: 14,
      label: t("products.internalSku"),
      field_name: "internal_sku",
      render: (row) => (
        <div
          onClick={() =>
            setUpdateSKUModal({
              row,
            })
          }
          className="wptable__quantity_column"
        >
          {row?.product_warehouse[0]["warehouse_sku"] || "-"}
        </div>
      ),
    },
    {
      id: 15,
      label: t("products.location"),
      field_name: "location",
      render: (row) => (
        <div
          onClick={() =>
            setUpdateLocationModal({
              row,
            })
          }
          className="wptable__quantity_column"
        >
          {row?.product_warehouse[0]["location"] || "-"}
        </div>
      ),
    },
    {
      id: 16,
      label: t("products.fulfilmentCost"),
      field_name: "fulfilment_cost",
      render: (row) => (
        <div
          onClick={() =>
            setUpdateFulfilmentCostModal({
              row,
            })
          }
          className="wptable__quantity_column"
        >
          {row?.fulfillment_cost || "-"}
        </div>
      ),
    },
    {
      id: 17,
      label: t("products.action"),
      field_name: "action",
      render: (row, rowIndex, handleFieldChange) => (
        <ActionDropDown
          setProdDetailsModal={setProdDetailsModal}
          rowIndex={rowIndex}
          handleFieldChange={handleFieldChange}
          setProdHistoryModal={setProdHistoryModal}
          setLabelModal={setLabelModal}
          navigate={navigate}
          row={row}
        />
      ),
      width: "400px",
      fixed: "right",
    },
  ];

  const getAllProducts = async (page, perPage, filter, nestedSearch) => {
    const response = await fetchAllWarehouseProducts(
      page,
      perPage,
      filter,
      user.warehouse_id,
      nestedSearch,
    );
    if (!response.error) {
      setProducts(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  return (
    <>
      <LabelModal
        open={labelModal}
        setOpen={setLabelModal}
        setSnack={setSnack}
        labelData={{
          code: labelModal?.row?.code,
          name: labelModal?.row?.name,
          image: labelModal?.row?.media?.find((image) => image?.is_primary)
            ?.file,
        }}
        title={t("products.productsBarcode")}
        subtitle={`${labelModal?.row?.full_name ?? ""} (${
          labelModal?.row?.code ?? ""
        })`}
      />
      <ProductDimensionModal
        open={prodDimensionModal}
        setOpen={setProdDimensionModal}
        Products={Products}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <ProductWeightModal
        open={productWeightModal}
        setOpen={setProductWeightModal}
        Products={Products}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <ProductFulfilmentCostModal
        open={updateFulfilmentCostModal}
        setOpen={setUpdateFulfilmentCostModal}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <ProductLocationModal
        open={updateLocationModal}
        setOpen={setUpdateLocationModal}
        setProdHistoryModal={setProdHistoryModal}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <ProductSKUModal
        open={updateSKUModal}
        setOpen={setUpdateSKUModal}
        setProdHistoryModal={setProdHistoryModal}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <WarehouseProductQty
        open={updateQuantityModal}
        setOpen={setUpdateQuantityModal}
        setProdHistoryModal={setProdHistoryModal}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <ProductDetailsModal
        open={prodDetailsModal}
        setOpen={setProdDetailsModal}
        setSnack={setSnack}
      />
      <ProductHistoryModal
        open={prodHistoryModal}
        setOpen={setProdHistoryModal}
      />
      <ImagesModal
        open={imagesModal}
        setOpen={setImagesModal}
        setSnack={setSnack}
        Products={Products}
        setProducts={setProducts}
      />
      <StorageBreakdownModal
        open={prodStorageModal}
        setOpen={setProdStorageModal}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ProductTable
          tableTitle={t("products.products")}
          tableId="WarehouseProductTable"
          message={t("products.noProductsToDisplay")}
          searchPlaceHolder={t("products.searchProducts")}
          columns={columns}
          data={Products}
          getAllData={getAllProducts}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          selectable={true}
          headerButtons={
            <div className="flex gap-1 flex-wrap">
              <BoltButton
                icon={FcPlus}
                label={t("products.addProduct")}
                onClick={() => navigate("/warehouse-AddProduct")}
                variant="success"
                size="sm"
              />
            </div>
          }
        />
        <BulkActionBar
          count={selectedRows.length}
          onClear={() => setSelectedRows([])}
        >
          <BulkActionButton
            label={t("products.exportSelected")}
            onClick={() =>
              generateExcelFile(Products?.data, selectedRows, setSnack)
            }
            icon={PiExportLight}
          />
        </BulkActionBar>
      </div>
    </>
  );
};

export default WarehouseProduct;
